import { useRef } from 'react';
import { Task } from '../components/organism.task/_task.js';
import { TaskContext } from '../components/organism.task/context.js';
import { TaskContainerContext } from '../components/organism.task/hook.task-breakpoints.js';
import { PrintTaskSummary } from '../page.results/molecule.task-accordion/molecule.summary.js';
import { useOpgavekompleksetComponent } from '../state/context.data.js';
import { useOpgavekompleksetEntry } from '../state/hook.entry.js';
import { shouldShowReport } from '../state/util.should-show-report.js';
import { wrapper } from './chunk.task.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function PrintTaskChunk(props) {
  const ref = useRef(null);
  const component = useOpgavekompleksetComponent();
  const taskEntry = useOpgavekompleksetEntry({
    select: entry => entry?.data.tasks[props.task.id]
  });
  const hasFinsihedEntry = useOpgavekompleksetEntry({
    select: entry => !entry ? false : entry.envelope.result?.status === "completed"
  });
  const isSkipped = taskEntry?.state.skipped ?? true;
  return /*#__PURE__*/jsx(TaskContainerContext.Provider, {
    value: ref,
    children: /*#__PURE__*/jsx(TaskContext.Provider, {
      value: hasFinsihedEntry ? shouldShowReport(component.data.settings.flowType) ? "facit" : "readonly" : "input",
      children: /*#__PURE__*/jsxs("div", {
        ref: ref,
        className: wrapper,
        children: [/*#__PURE__*/jsx(PrintTaskSummary, {
          index: props.index,
          task: props.task,
          avoidBreakAfter: !isSkipped
        }, props.task.id), !isSkipped && /*#__PURE__*/jsx(Task, {
          task: props.task,
          taskIndex: props.index
        })]
      })
    })
  });
}

export { PrintTaskChunk };
//# sourceMappingURL=chunk.task.js.map
